var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('div',{staticClass:"text-center m-3 px-3 rounded border border-danger"},[_c('p',{staticClass:"d-block invalid-feedback",staticStyle:{"font-size":"1rem"}},[_vm._v(" "+_vm._s(_vm.$t('error.general'))+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }